import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { MeetingAgendaItem } from "@common/ADAPT.Common.Model/organisation/meeting-agenda-item";
import { emptyIfUndefinedOrNull } from "@common/lib/utilities/rxjs-utilities";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { IMeetingAgendaDetail, MeetingAgendaType, MeetingsService } from "@org-common/lib/meetings/meetings.service";
import { HidingEvent } from "devextreme/ui/popover";
import { DxPopoverComponent } from "devextreme-angular";
import { defer, Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
    selector: "adapt-display-agenda-name",
    templateUrl: "./display-agenda-name.component.html",
    styleUrl: "./display-agenda-name.component.css",
    standalone: false,
})
export class DisplayAgendaNameComponent extends BaseComponent {
    public readonly MeetingAgendaType = MeetingAgendaType;

    @Input() public isSelected = false;
    @Input() public agendaDetail!: IMeetingAgendaDetail;
    @Output() public agendaClicked = new EventEmitter<IMeetingAgendaDetail>();

    public agendaItems$: Observable<MeetingAgendaItem[]>;

    public popoverVisible = false;
    public popoverCancelHiding = false;

    @ViewChild(DxPopoverComponent) private popoverComponent?: DxPopoverComponent;

    public constructor(
        meetingsService: MeetingsService,
    ) {
        super();

        this.agendaItems$ = defer(() =>
            meetingsService.getAgendaItemsForMeetingAgendaTemplate(this.agendaDetail.meetingTemplate.meetingAgendaTemplateId).pipe(
                map((items: MeetingAgendaItem[]) =>
                    items.filter((item) =>
                        meetingsService.canAccessFacilitationNote || !item.extensions.isFacilitationNotes,
                    ),
                ),
                emptyIfUndefinedOrNull(),
                this.takeUntilDestroyed(),
            ),
        );
    }

    public get meetingAgendaTemplateIdAttr() {
        return `meetingAgendaTemplateId${this.agendaDetail.meetingTemplate.meetingAgendaTemplateId}`;
    }

    // handling the case where description is too long than we need a scroll view
    // - has to prevent the popover from going away if pointer moved to the popover content
    //   and cancel hiding

    public preventHide() {
        this.popoverComponent?.instance.option("visible", true);
        this.popoverCancelHiding = true;
        this.popoverVisible = true;
    }

    public allowHide() {
        this.popoverCancelHiding = false;
        this.popoverVisible = false;
    }

    public onPopoverHiding(e: HidingEvent) {
        if (this.popoverCancelHiding) {
            e.cancel = true;
        }
    }

    public onButtonClicked() {
        this.agendaClicked.emit(this.agendaDetail);
        setTimeout(() => this.allowHide(), 200); // hide the popover when button click (popover only shows after 100ms - 200ms to be safe)
    }

    public iconTooltip() {
        return this.agendaDetail.type === MeetingAgendaType.System
            ? "This is a system-defined template"
            : "This is a system-defined template for coaches only";
    }
}
